import type { Element } from 'slate';

export const createParagraphNode = (text = ''): Element => ({
  type: 'paragraph',
  children: [
    {
      text,
    },
  ],
});

// Future text-related nodes can be added here
export const createHeadingNode = (level: number, text = ''): Element => ({
  type: `heading-${level}`,
  children: [
    {
      text,
    },
  ],
});
